import { EventListenerFocusTrapInertStrategy } from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import {NONE_TYPE } from '@angular/compiler';
import { Injectable } from '@angular/core'
//import { DefaultGridAutoDirective } from '@angular/flex-layout/grid/typings/auto/auto';
import { endOfDay } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { endpoints } from 'src/app/v2-node-api/common/api-endpoints';
import { DataService } from 'src/app/v2-node-api/services/data.service';
import { Card, Column } from '../models/column.model';
import { APIHelper } from './api-helper/api-helper.service';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root',
})
export class BoardService extends DataService { 
 
  constructor(http: HttpClient, private api : APIHelper,private userService: UserService,
    ){
    super(endpoints.kanban, http);

  }
getColumns(kanbanId){
  
  return  this.http.get<any>(endpoints.kanban + `list-columns/${kanbanId}`);
}
getKanbans(){
  return  this.http.get<any[]>(endpoints.kanban + `list-kanban/`);
}

getKanban(kanbanId){
  return  this.http.get<any>(endpoints.kanban + `get-kanban/${kanbanId}`);
}

updateKanban(kanbanId, privacy, listPeopleAuthorized, kanban){
  const newKanban ={
    creator : kanban.creator,
    title: kanban.title,
    columnList: kanban.columnList,
    privacy: privacy,
    listPeopleAuthorized: listPeopleAuthorized
    }
  return this.http.put(endpoints.kanban + `update/${kanbanId}`, newKanban)
}


addKanbanTask(title, description ,kanbanId, affectto,dueDate,file, columnId){

    const newCard = {
    id: Date.now(),
    description: description,
    order: "",
    author: this.userService.user.completeName,
    like: 0,
    document: file,
    senderAffect: this.userService.user.email,
    senderName: this.userService.user.completeName,
    email:"",
    dueDate: dueDate,
    affectto: affectto,
    base64: "",
    comments: [],
    text: title,
    cloture: false

  };
  return this.http.post<any[]>(endpoints.kanban + `add-task/${kanbanId}/${columnId}`, newCard) 
}
removeAffect(kanbanid, columnid, taskid, task, user){
  if(task){
    const data= {
      task:task,
      userTodelete:user
    }
    return this.http.put<any[]>(endpoints.kanban + `/remove-affectto/${kanbanid}/${columnid}/${taskid}`, data)
  }
}
addAffect(affectto,email,kanbanId, columnId, task, kanbanTitle){
  if(affectto.length == 0){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: task.affectto,
      senderAffect: this.userService.user.email,
      senderName: this.userService.user.completeName,
      like: task.like,
      base64: task.base64,
      dueDate: task.dueDate,
      kanbanTitle:kanbanTitle,
      nameFile:task.nameFile,
      email:email,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture
    };

    

    return this.http.put<any[]>(endpoints.kanban + `update-affectto/${kanbanId}/${columnId}/${task._id}`, newCard)

  }
  else{
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: affectto,
      base64: task.base64,
      senderAffect: this.userService.user.email,
      senderName: this.userService.user.completeName,
      like: task.like,
      dueDate: task.dueDate,
      kanbanTitle:kanbanTitle,
      nameFile: task.nameFile,
      email:email,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture
  
    };
    return this.http.put<any[]>(endpoints.kanban + `update-affectto/${kanbanId}/${columnId}/${task._id}`, newCard)

  }
  
}

EditTitleKanban($event, kanbanId, kanban){
  if($event){
    const newKanban ={
      creator : kanban.creator,
      taskTotal : kanban.taskTotal,
      title: $event,
      columnList: kanban.columnList,
      privacy: kanban.privacy,
      listPeopleAuthorized: kanban.listPeopleAuthorized
      }
      return this.http.put<any[]>(endpoints.kanban + `update-kanban-title/${kanbanId}`, newKanban)
  };
}

EditTitleDescriptionColumn($event,kanbanId, columnId, task){

  if($event.title && $event.description){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: $event.description,
      affectto: task.affectto,
      base64: task.base64,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email,  
      nameFile: task.nameFile,
      dueDate: task.dueDate,
      like: task.like,
      comments: task.comments,
      text: $event.title,
      cloture: task.cloture

    }
    return this.http.put<any[]>(endpoints.kanban + `update-text/${kanbanId}/${columnId}/${task._id}`, newCard)

  }else if($event.title == null && $event.description){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: $event.description,
      affectto: task.affectto,
      like: task.like,
      dueDate: task.dueDate,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
      nameFile: task.nameFile,
      base64: task.base64,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture

    }
    return this.http.put<any[]>(endpoints.kanban + `update-description/${kanbanId}/${columnId}/${task._id}`, newCard)

  }else if($event.description  == null && $event.title){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      base64: task.base64,
      description: task.description,
      affectto: task.affectto,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
      like: task.like,
      comments: task.comments,
      nameFile: task.nameFile,
      dueDate: task.dueDate,
      text: $event.title,
      cloture: task.cloture

    }
    return this.http.put<any[]>(endpoints.kanban + `update-text/${kanbanId}/${columnId}/${task._id}`, newCard)

  }
}

EditDueDate($event,kanbanId, columnId,task){
  const newCard = {
    id: task._id,
    order: task.order,
    author: task.author,
    base64: task.base64,
    description: task.description,
    affectto: task.affectto,
    like: task.like,
    senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
    nameFile: task.nameFile,
    comments: task.comments,
    dueDate: $event.dueDate,
    text: task.title,
    cloture: task.cloture
  }

  return this.http.put<any[]>(endpoints.kanban + `update-dueDate/${kanbanId}/${columnId}/${task._id}`, newCard)

}

public getRandomColor() {
  const colors: string[] = [ '00BFFF', 'FFC0CB', 'DDA0DD', 'FA8072', '40E0D0',  'FF99CC',  '66CCFF', 'F4A460',   '87CEFA', 'FFB6C1', '666665', '4f27b2', '2fb227', 'b0b227', 'b25a27', 'b22795', 'b22742', '8427b2', 'cf0042', '35cf00', 'cfbf00'];
  return '#' + colors[Math.floor(Math.random() * colors.length)];
}

addKanban(title){
 const newKanban ={
  creator : this.userService.user.completeName,
  taskTotal : 0,
  title: title,
  columnList: [],
  privacy: 'public',
  listPeopleAuthorized: []
  }
  return this.http.post<any>(endpoints.kanban + `add-kanban`, newKanban)
}

 deleteCard(kanbanId, columnId, taskId) {
  return this.http.delete<any[]>(endpoints.kanban + `remove-task/${kanbanId}/${columnId}/${taskId}`)

  }

  deleteColumn(kanbanId, columnId) {
    return this.http.delete<any[]>(endpoints.kanban + `remove-column/${kanbanId}/${columnId}`)

  }

  addColumn(title: string, kanbanId, addkanban, aFaire , aCours, finis, order) {
    if(addkanban && aFaire ){
      const newColumn = {
        id: Date.now(),
        title: title,
        taskTotal : 0,
        order: 0,
        color: "#D37B55",
        taskList: [],
      };
      return this.http.post<any>(endpoints.kanban + `add-column/${kanbanId}`, newColumn)

    } else if(addkanban && aCours ){
      const newColumn = {
        id: Date.now(),
        title: title,
        taskTotal : 0,
        order: 1,
        color: "#35627E",
        taskList: [],
      };
      return this.http.post<any>(endpoints.kanban + `add-column/${kanbanId}`, newColumn)

    } else if(addkanban && finis){
      const newColumn = {
        id: Date.now(),
        title: title,
        taskTotal : 0,
        order: 2,
        color: "#598A56",
        taskList: [],
      };
      return this.http.post<any>(endpoints.kanban + `add-column/${kanbanId}`, newColumn)

    }else{
      const newColumn = {
        id: Date.now(),
        title: title,
        taskTotal : 0,
        order: order,
        color: this.getRandomColor(),
        taskList: [],
      };
      return this.http.post<any>(endpoints.kanban + `add-column/${kanbanId}`, newColumn)

    }
 
  }

  addComment(comment, columnId, taskId) {
    const newComment = {
      id: Date.now(),
      text: comment,
      author: this.userService.user.completeName,
    };
    return this.http.post<any[]>(endpoints.kanban + `add-comment/${columnId}/${taskId}`, newComment)
  }

  deleteComment(columnId, taskId, commentId) {
    return this.http.delete<any[]>(endpoints.kanban + `remove-comment/${columnId}/${taskId}/${commentId}`)
  }

  changeColumnColor(color, kanbanId, columnId) {
    const newColumn = {
      id: "",
      title: "",
      taskTotal: "",
      order:0,
      color: color,
      taskList: [],
    };
    return  this.http.put<any[]>(endpoints.kanban + `change-color/${kanbanId}/${columnId}`, newColumn);
  }

  // nbTasktotal(nbTask, kanbanId, columnId) {
  //   const newColumn = {
  //     id: "",
  //     title: "",
  //     color: "",
  //     taskTotal: nbTask ,
  //     taskList: [],
  //   };
  //   return  this.http.put<any[]>(endpoints.kanban + `update-number-task/${kanbanId}/${columnId}`, newColumn);
  // }

  changeColumnName(title, kanbanId, columnId) {
    const newColumn = {
      id: "",
      title: title,
      color: "",
      order:0,
      taskTotal: "",
      taskList: [],
    };
    return  this.http.put<any[]>(endpoints.kanban + `change-column-name/${kanbanId}/${columnId}`, newColumn);
  }

  changeLike(event: boolean, columnId: number, cardId: number) {

    const newCard = {
      id: Date.now(),
      author: "Admin",
      like: "",
      comments: [],
      text: "",
    };
    return  this.http.put<any[]>(endpoints.kanban + `likes/${columnId}/${cardId}`, newCard);
  }



  changeColumnId(kanbanId, previousColumn, currentColumn, task){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: task.affectto,
      dueDate: task.dueDate,
      nameFile: task.nameFile,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
      base64: task.base64,
      like: task.like,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture

    };  

   return  this.http.post<any[]>(endpoints.kanban + `changecolumn/${kanbanId}/${previousColumn}/${currentColumn}/${task._id}`, newCard)
  }

  changeColumnOrder(kanbanId, column, index){
    const newColumn = {
      id: column._id,
      title: column.title,
      color: column.color,
      order: index,
      taskTotal: column.taskTotal,
      taskList: column.taskList,
    };
    return  this.http.put<any[]>(endpoints.kanban + `change-column-order/${kanbanId}/${column._id}`, newColumn);
  }

  changeAllColumnOrder(kanbanId, column, index){
    const newColumn = {
      id: column._id,
      title: column.title,
      color: column.color,
      order: index,
      taskTotal: column.taskTotal,
      taskList: column.taskList,
    };
    return  this.http.put<any[]>(endpoints.kanban + `change-column-order/${kanbanId}/${column._id}`, newColumn);
  }

  changeorder(currentColumn, currentIndex, task){
    const newCard = {
      id: task._id,
      order: currentIndex,
      description: task.description,
      document: task.file,
      author: task.author,
      like: task.like,
      comments: task.comments,
      text: task.text
    }
    return  this.http.put<any[]>(endpoints.kanban + `changeorder/${currentColumn}/${task._id}/${currentIndex}`, newCard)
  }
  deleteKanban(kanbanId){
    return  this.http.delete<any[]>(endpoints.kanban + `remove-kanban/${kanbanId}`)
  }
  cloture(kanbanId, columnId, task){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      nameFile: task.nameFile,
      description: task.description,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
      affectto: task.affectto,
      dueDate: task.dueDate,
      base64: task.base64,
      like: task.like,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture
    };  
    return this.http.put<any[]>(endpoints.kanban + `cloture/${kanbanId}/${columnId}/${task._id}`, newCard)

  }
  open(kanbanId, columnId, task){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: task.affectto,
      dueDate: task.dueDate,
      nameFile: task.nameFile,
      base64: task.base64,
      senderAffect: task.senderAffect,
      senderName: task.senderName,
      email:task.email, 
      like: task.like,
      comments: task.comments,
      text: task.text,
      cloture: task.cloture
    };  
    return this.http.put<any[]>(endpoints.kanban + `open/${kanbanId}/${columnId}/${task._id}`, newCard)

  }


}